import { Card, CardHeader, List } from '@material-ui/core';
import React, { Component } from 'react';
import { getCurrentFunctionName } from '../../performanceModeManager';
import QuoteListDetail from './QuoteListDetail';

class QuotesAsCards extends Component {

    render() {
        console.perfLog(getCurrentFunctionName());

        let details = [];

        if (this.props.filteredAndSortedQuotes.length <= 0)
            return (
                <Card className="card">
                    <CardHeader title={"Aucun résultat"} className="text-center" titleTypographyProps={{ variant: "h6", color: 'primary' }} />
                </Card>
            );

        this.props.filteredAndSortedQuotes
            .filter((q) => !q.deleted)
            .forEach((q) => {
                details.push(
                    <QuoteListDetail
                        globalContainer={this.props.globalContainer}
                        className="quote-list-detail"
                        key={q.code}
                        quote={q}
                    />
                );
            });

        return <List className="row">{details.map((d) => d)}</List>;
    }
}

export default QuotesAsCards;
